const CHILD_VIEWPORT_STATE_PREFIX = 'childViewportState:';
const CHILD_VIEWPORT_KEY_STORAGE = 'childViewportKey';
export const CHILD_VIEWPORT_WINDOW_NAME_PREFIX = 'alma-child-viewport:';

export const getChildLayoutKey = () => {
  if (typeof window === 'undefined') return null;

  let layoutKey = new URLSearchParams(window.location.search).get('sid');
  if (!layoutKey && window.name.startsWith(CHILD_VIEWPORT_WINDOW_NAME_PREFIX)) {
    layoutKey = window.name.slice(CHILD_VIEWPORT_WINDOW_NAME_PREFIX.length) || null;
  }

  try {
    if (layoutKey) {
      window.sessionStorage.setItem(CHILD_VIEWPORT_KEY_STORAGE, layoutKey);
      return layoutKey;
    }
    return window.sessionStorage.getItem(CHILD_VIEWPORT_KEY_STORAGE);
  } catch (error) {
    return layoutKey;
  }
};

export const getChildViewportState = () => {
  const layoutKey = getChildLayoutKey();
  if (!layoutKey) return null;
  try {
    const storageKey = `${CHILD_VIEWPORT_STATE_PREFIX}${layoutKey}`;
    const storedState = window.localStorage.getItem(storageKey);
    const sessionState = storedState || window.sessionStorage.getItem(storageKey);
    if (!sessionState) return null;

    const parsedState = JSON.parse(sessionState);
    if (storedState) {
      try {
        window.sessionStorage.setItem(storageKey, storedState);
      } catch (storageError) {
        // Keep using the localStorage copy if sessionStorage is unavailable.
      }
    }
    return parsedState;
  } catch (error) {
    return null;
  }
};

export const isChildViewport = () => Boolean(getChildLayoutKey());
